// One colour per concept category, shared by the graph, the badges and the legend. Categories come
// from the enrichment (`data.category` on the build); anything unknown falls back to slate.
const COLORS: Record<string, string> = {
  style: '#7c3aed',
  color: '#db2777',
  technique: '#2563eb',
  composition: '#0891b2',
  theme: '#16a34a',
  subject: '#ca8a04',
  mood: '#ea580c',
  medium: '#4f46e5',
  merch: '#9333ea',
  other: '#64748b',
}

export function categoryColor(category: string | null | undefined): string {
  return (category && COLORS[category]) || '#64748b'
}

export const SOURCE_LABEL: Record<string, string> = {
  legacy_2024: '2024 graph',
  enrichment_v2: 'Enrichment v2',
}
